import { logService } from '../logs'

export type EnvConfig = {
  BASE_URL: string
  FIREBASE_API_KEY: string
  FIREBASE_AUTH_DOMAIN: string
  FIREBASE_PROJECT_ID: string
  FIREBASE_STORAGE_BUCKET: string
  FIREBASE_MESSAGING_SENDER_ID: string
  FIREBASE_APP_ID: string
  PIXEL_ID: string
  MAPS_API_KEY: string
  STRIPE_KEY: string
  PAYPAL_CLIENT_ID: string
  FLATLANE_PLACE_ID: string
  GOOGLE_TRACKING_ID: string
  GOOGLE_ANALYTICS_ID: string
  BANNER_BG_URL: string
  NODE_ENV: string
}

export interface IEnvService {
  get<K extends keyof EnvConfig>(key: K): EnvConfig[K]
}

export const createEnvService = (): IEnvService => {
  const config: EnvConfig = {
    BASE_URL: process.env.NEXT_PUBLIC_BASE_URL ?? '',
    FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? '',
    FIREBASE_AUTH_DOMAIN: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    FIREBASE_PROJECT_ID: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? '',
    FIREBASE_STORAGE_BUCKET:
      process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? '',
    FIREBASE_MESSAGING_SENDER_ID:
      process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? '',
    FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID ?? '',
    PIXEL_ID: process.env.NEXT_PUBLIC_PIXEL_ID ?? '',
    MAPS_API_KEY: process.env.NEXT_PUBLIC_MAPS_API_KEY ?? '',
    STRIPE_KEY: process.env.NEXT_PUBLIC_STRIPE_KEY ?? '',
    PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID ?? '',
    FLATLANE_PLACE_ID: process.env.NEXT_PUBLIC_FLATLANE_PLACE_ID ?? '',
    GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID ?? '',
    GOOGLE_TRACKING_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID ?? '',
    NODE_ENV: process.env.NODE_ENV ?? 'development',
    BANNER_BG_URL: process.env.NEXT_PUBLIC_BANNER_BG_URL ?? 'development',
  }

  if (config.NODE_ENV === 'production') {
    Object.entries(config).forEach(([key, value]) => {
      if (!value) {
        logService.warn(`[EnvService] Missing environment variable: ${key}`)
      }
    })
  }

  return {
    get: <K extends keyof EnvConfig>(key: K): EnvConfig[K] => {
      return config[key]
    },
  }
}
